<template>
    <AdminPanelUsersList />
</template>

<script>
import UsersList from '../components/AdminPanelUsersList.vue'
export default {
    data: () => ({}),
    components: {
        UsersList
    },
    methods: {},
    mounted() {}
}
</script>
